import cls from "pages/MainPage/ui/MainPage.module.scss";
import { classNames } from "shared/lib/classNames/classNames";
import Title from "shared/ui/Title/Title";
import Paragraph, { ParagraphTheme } from "shared/ui/Paragraph/Paragraph";

const PrivacyPage = () => {
    return (
        <div id={"mainPage"} className={cls.indexPage}>
            <section className={classNames("page-section", {}, [cls.indexPage__about])}>
                <div className={classNames("container container__main")}>
                    <div className={cls.About}>
                        <div className={cls.About__info}>
                            <Title className={cls.indexPage__title} sentences={["Privacy Policy"]} />

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                HYPERAD LAB LTD. built the Brainrot Creatures Games and Squid Brainrot Games apps as a Free app. This SERVICE is provided by HYPERAD LAB LTD. at no cost and is intended for use as is.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information for anyone who decides to use our Service.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which are accessible at Brainrot Creatures Games and Squid Brainrot Games unless otherwise defined in this Privacy Policy.
                            </Paragraph>

                            <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                                <Title sentences={["Information Collection and Use"]} />
                            </div>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information. The information that we request will be retained on your device and is not collected by us in any way.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                The app does use third-party services that may collect information used to identify you.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Link to the privacy policy of third-party service providers used by the app:
                            </Paragraph>

                            <ul style={{ marginLeft: "20px", marginBottom: "1.5rem", color: "var(--bright-text-color, #fff)" }}>
                                <li style={{ marginBottom: "0.5rem" }}>Google Play Services</li>
                                <li style={{ marginBottom: "0.5rem" }}>AdMob</li>
                                <li style={{ marginBottom: "0.5rem" }}>Google Analytics for Firebase</li>
                                <li style={{ marginBottom: "0.5rem" }}>Firebase Crashlytics</li>
                                <li style={{ marginBottom: "0.5rem" }}>Facebook</li>
                            </ul>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We want to inform you that whenever you use our Service, in the case of an error in the app, we collect data and information (through third-party products) on your phone called Log Data. This Log Data may include information such as your device's Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when using our Service, the time and date of your use of the Service, and other statistics.
                            </Paragraph>

                            <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                                <Title sentences={["Cookies"]} />
                            </div>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                This Service does not use these “cookies” explicitly. However, the app may use third-party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
                            </Paragraph>

                            <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                                <Title sentences={["Service Providers"]} />
                            </div>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We may employ third-party companies and individuals for the following reasons:
                            </Paragraph>

                            <ul style={{ marginLeft: "20px", marginBottom: "1.5rem", color: "var(--bright-text-color, #fff)" }}>
                                <li style={{ marginBottom: "0.5rem" }}>To facilitate our Service;</li>
                                <li style={{ marginBottom: "0.5rem" }}>To provide the Service on our behalf;</li>
                                <li style={{ marginBottom: "0.5rem" }}>To perform Service-related services; or</li>
                                <li style={{ marginBottom: "0.5rem" }}>To assist us in analyzing how our Service is used.</li>
                            </ul>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We want to inform users of this Service that these third parties have access to their Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
                            </Paragraph>

                            <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                                <Title sentences={["Security"]} />
                            </div>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We value your trust in providing us your Personal Information, thus we strive to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
                            </Paragraph>

                            <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                                <Title sentences={["Links to Other Sites"]} />
                            </div>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                            </Paragraph>

                            <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                                <Title sentences={["Children’s Privacy"]} />
                            </div>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13 years of age. If we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we can take the necessary actions.
                            </Paragraph>

                            <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                                <Title sentences={["Changes to This Privacy Policy"]} />
                            </div>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                This policy is effective as of 2025-05-11.
                            </Paragraph>

                            <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                                <Title sentences={["Contact Us"]} />
                            </div>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at <span style={{ color: "var(--primary-color, #4285f4)", textDecoration: "underline" }}>info@hyperadlab.com</span>
                            </Paragraph>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PrivacyPage;
